import { Form, Input, Select, Space, Row, Col, Checkbox, Modal, message } from 'antd';
import './profile.css';
import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { GreenButton } from '../../components/button/GreenButton';
import { CancelButton } from '../../components/button/CancelButton';
import { GuestLayout } from '../../components/layout/guest-layout';
import Cookies from 'js-cookie';
import { useParams } from "react-router";
import thJson from '../../jsondata/thailand_address.json';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config
    );
    console.log(config);
    data = await response.data;
    return data;
  } catch (error) {
    throw error.response;
  }
};

export default function Profile() {
  const { phone_cust } = useParams();
  const [datacust, setdatacust] = useState([]);
  const [form] = Form.useForm()

  useEffect(() => {
    if (Cookies.get('phone') != phone_cust) {
      Cookies.remove('jwt');
      Cookies.remove('phone');
      window.location = '/register-warranty/login';
    }
    thaiprovince();
    // Define your API post request here
    const postPhonenumtoedit = async () => {
      try {

        const response = await POST('warranty/get_cust_by_phone_num/', { cust_phone_number: phone_cust });
        if (response) {
          setdatacust(response[0]);

          const splitname = response[0].cust_fullname.split(" ");
          console.log(response[0]);
          console.log(splitname[0]);
          setformValue({
            ...formValue,
            cust_firstname: splitname[0],
            cust_lastname: splitname[1],
            cust_prefix: response[0].cust_prefix,
            cust_fullname: response[0].cust_fullname,
            cust_address: response[0].cust_address,
            cust_sub_district: response[0].cust_sub_district,
            cust_District: response[0].cust_District,
            cust_city: response[0].cust_city,
            cust_Postcode: response[0].cust_postcode,
            cust_email: response[0].cust_email,
            email: response[0].email,
          });
          setemailcheck(response[0].email === '1');

          form.setFieldsValue({ 
            cust_city: response[0].cust_city,
            cust_District: response[0].cust_District, 
            cust_sub_district: response[0].cust_sub_district, 
            cust_Postcode: response[0].cust_postcode 
          });
          // form.setFieldsValue({
          //   prefix: response.data[0].cust_prefix,
          //   cust_firstname: splitname[0],
          //   cust_lastname: splitname[1],
          //   cust_address: response.data[0].cust_address,
          //   cust_sub_district: response.data[0].cust_sub_district,
          //   cust_District: response.data[0].cust_District,
          //   cust_city: response.data[0].cust_city,
          //   cust_Postcode: response.data[0].cust_postcode,
          //   cust_email: response.data[0].cust_email,
          // });
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Call the postData function when the Home component is rendered
    postPhonenumtoedit();
  }, []);

  async function handleSubmit() {
    console.log(formValue);
    await POST('warranty/update_customer/', formValue)
      .then(response => {
        message.open({
          type: 'success',
          content: 'บันทึกสำเร็จ',
          style: {
            marginTop: '8vh',
            fontSize: '16px'
          },
        });
        // window.location = './order_list';
        window.location = `/register-warranty/order_list/${phone_cust}`;
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
  }
  // const handleSubmit = async (e) => {
  async function onFinish(values) {
    if (values.cust_email === '' || values.cust_prefix === '' || values.cust_firstname === '' || values.cust_lastname === '' || values.cust_address === '' || values.cust_sub_district === '' || values.cust_District === '' || values.cust_city === '' || values.cust_Postcode === '') {
      message.open({
        type: 'error',
        content: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        style: {
          marginTop: '8vh',
          fontSize: '16px'
        },
      });
      setsecondsubmit(false);
    }
    else {
      setformValue({
        ...formValue,
        // cust_prefix: values.cust_prefix,
        cust_firstname: values.cust_firstname,
        cust_lastname: values.cust_lastname,
        cust_fullname: values.cust_firstname + " " + values.cust_lastname,
        cust_address: values.cust_address,
        cust_email: values.cust_email,
      });
      console.log("this is", values);
    }
  }

  const [email, setemailcheck] = useState(false);
  //     const splitname = datacust.cust_fullname ? datacust.cust_fullname.split(" ") : [];
  //     const firstname = splitname[0];
  //     const lastname = splitname[1]; 
  const [formValue, setformValue] = useState({
    cust_phone_number: phone_cust,
    cust_prefix: '',
    cust_firstname: '',
    cust_lastname: '',
    cust_fullname: '',
    cust_address: '',
    cust_sub_district: '',
    cust_District: '',
    cust_city: '',
    cust_Postcode: '',
    cust_email: '',
    consent_pdpa: '1',
    email: '',
    sms: '',

  });

  const datatest = 'test';


  // const datainputChange = (e) => {

  //   setformValue({
  //     ...formValue,
  //     [e.target.name]: e.target.value,
  //     cust_fullname: formValue.cust_firstname + ' ' + formValue.cust_lastname
  //   });
  // }
  const datainputselect = (e) => {
    setformValue({
      ...formValue,
      cust_prefix: e
    });
  }

  const firstsubmitfn = () => {
    console.log(phone_cust);
    setfirstsubmit(true);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
  const secondsubmitfn = () => {
    setsecondsubmit(true);
  }


  const [secondsubmit, setsecondsubmit] = useState(false);
  const [disablebutton2, setdisablebutton2] = useState(true);
  const [disablebutton1, setdisablebutton1] = useState(false);

  const [firstsubmit, setfirstsubmit] = useState(false);
  const [checkbox, setcheckbox] = useState(true);
  const [disableinput, setdisableinput] = useState(true);
  const [inputshow, setinputshow] = useState(false);
  const [disablebutton, setdisablebutton] = useState(false);

  useEffect(() => {
    if (firstsubmit === true) {

      setdisableinput(false);
      setdisablebutton(true);
      setdisablebutton1(true);
      setcheckbox(false);


      // if(formValue.firstname==''){
      //   alert("กรุณาใส่ข้อมูล");
      // }
    }
  }, [firstsubmit]);

  useEffect(() => {
    if (secondsubmit === true) {
      message.open({
        type: 'warning',
        content: 'กรุณาตรวจสอบข้อมูลก่อนบันทึก',
        style: {
          marginTop: '8vh',
          fontSize: '16px'
        },
      });
      setdisableinput(true);
      setdisablebutton2(false);
      setdisablebutton(false);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [secondsubmit]);

  useEffect(() => {
    if (email) {
      setformValue({
        ...formValue,
        email: '1',
        sms: '1'
      });
    }
    else {
      setformValue({
        ...formValue,
        email: '0',
        sms: '0'
      });
    }
  }, [email]);

  const disables = () => {
    setdisableinput(true);
    setdisablebutton(false);
    setfirstsubmit(false);
    setdisablebutton1(false);
    setcheckbox(true);
  }
  const disables2 = () => {
    setsecondsubmit(false);
    setdisableinput(false);
    setdisablebutton(true);
    setfirstsubmit(true);
    setdisablebutton1(true);
    setdisablebutton2(true);
  }
  const thj = thJson;
  const [province, setProvince] = useState('');
  const [tambons, setTambons] = useState('');
  const [provincethai, setProvincethai] = useState([]);
  const [DistrictThai, setDistrictThai] = useState([]);
  const [district, setdistricts] = useState('');
  const [TambonThai, setTambonThai] = useState([]);
  const [zipcodes, setzipcodes] = useState([]);
  // const [form] = Form.useForm()

  useEffect(() => {
    if (province) {

      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.ProvinceThai === province);

      let previousValue = null;
      const mappedJson = t.map((item) => {
        if (item.DistrictThaiShort === previousValue) {
          return null;
        }
        previousValue = item.DistrictThaiShort;
        return {
          value: item.DistrictThaiShort,
          label: item.DistrictThaiShort,
        };
      });

      setDistrictThai(mappedJson.filter(Boolean).map((item) => item));



    }
  }, [province]);

  useEffect(() => {
    if (district) {

      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.ProvinceThai === province);
      const ts = dup.filter((row) => row.DistrictThaiShort === district);

      let previousValue = null;
      const mappedJson = ts.map((item) => {
        if (item.TambonThaiShort === previousValue) {
          return null;
        }
        previousValue = item.TambonThaiShort;
        return {
          value: item.TambonThaiShort,
          label: item.TambonThaiShort,
        };
      });
      console.log(ts)

      setTambonThai(mappedJson.filter(Boolean).map((item) => item));



    }
  }, [district]);

  useEffect(() => {
    if (tambons) {

      const dup = thj.map(({ TambonID, ...rest }) => rest);
      const t = dup.filter((row) => row.TambonThaiShort === tambons);

      let previousValue = null;
      const mappedJson = t.map((item) => {
        if (item.PostCodeMain === previousValue) {
          return null;
        }
        previousValue = item.PostCodeMain;
        return {
          value: item.PostCodeMain,
          label: item.PostCodeMain,
        };
      });
      console.log(t)
      setzipcodes(mappedJson.filter(Boolean).map((item) => item));



    }
  }, [tambons]);


  const thaiprovince = () => {


    let previousValue = null;
    const mappedJson = thj.map((item) => {
      if (item.ProvinceThai === previousValue) {
        return null;
      }
      previousValue = item.ProvinceThai;
      return {
        value: item.ProvinceThai,
        label: item.ProvinceThai,
      };
    });

    setProvincethai(mappedJson.filter(Boolean).map((item) => item));
  };
  const provinceinput = (e) => {
    form.setFieldsValue({ cust_District: "", cust_sub_district: "", cust_Postcode: "" });
    console.log(e);
    setProvince(e);
    setformValue({
      ...formValue,
      cust_city: e
    });
  }

  const Tambon = (e) => {
    form.setFieldsValue({ cust_Postcode: "" });
    console.log(e);
    setTambons(e);
    setformValue({
      ...formValue,
      cust_sub_district: e
    });
  }

  const districts = (e) => {
    form.setFieldsValue({ cust_sub_district: "", cust_Postcode: "" });
    console.log(e);
    setdistricts(e);
    setformValue({
      ...formValue,
      cust_District: e
    });
  }  

  const postcodedata = (e) => {
    // form.setFieldValue({district: ""});

    setformValue({
      ...formValue,
      cust_Postcode: e
    });
  }

  const getCardWidth = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 280) {
      return 180;
    } else if (screenWidth > 280 && screenWidth <= 360) {
      return 260;
    } else if (screenWidth > 360 && screenWidth <= 375) {
      return 275.2;
    } else if (screenWidth > 375 && screenWidth <= 390) {
      return 290.4;
    } else if (screenWidth > 390 && screenWidth <= 393) {
      return 293.6;
    } else if (screenWidth > 393 && screenWidth <= 540) {
      return 300;
    } else {
      return 560;
    }
  };

  const [cardWidth, setCardWidth] = useState(getCardWidth());

  useEffect(() => {
    const handleResize = () => {
      setCardWidth(getCardWidth());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <GuestLayout title={"ข้อมูลส่วนตัว"}>
      <div className='textinput'>
        <div className='subtextinput'>
          <div className='title'>
            <h2>ข้อมูลส่วนตัว<br></br>Profile</h2>
          </div>
          {formValue.cust_prefix && (
            <Form layout="vertical" className='Form'
              form={form}
              onFinish={onFinish}
              
            >
              <Form.Item label={<span><span style={{ color: 'red' }}>*</span> <span style={{ color: 'black' }}>คำนำหน้าชื่อ</span></span>} name="prefix" initialValue={formValue.cust_prefix}>
                <Select disabled={disableinput} name="prefix" onChange={datainputselect} style={{ width: `${cardWidth}px` }}>
                  <Select.Option value="นาย">นาย (Mr.)</Select.Option>
                  <Select.Option value="นางสาว">นางสาว (Ms.)</Select.Option>
                  <Select.Option value="นาง">นาง (Mrs.)</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item rules={[{ required: true, message: 'กรุณากรอกชื่อ' }]} label="ชื่อ (First Name)" name="cust_firstname" initialValue={formValue.cust_firstname}>
                <Input placeholder="ชื่อจริง" disabled={disableinput} name="cust_firstname" />
              </Form.Item>

              <Form.Item rules={[{ required: true, message: 'กรุณากรอกนามสกุล' }]} label="นามสกุล (Last Name)" name="cust_lastname" initialValue={formValue.cust_lastname}>
                <Input placeholder="นามสกุล" disabled={disableinput} name="cust_lastname" required />
              </Form.Item>
              <Form.Item rules={[{ required: true, message: 'กรุณากรอกที่อยู่' }]} label="ที่อยู่ (Address)" name="cust_address" initialValue={formValue.cust_address}>
                <Input placeholder="ที่อยู่" disabled={disableinput} name="cust_address" />
              </Form.Item>

              <Form.Item rules={[{ required: true, message: 'กรุณากรอกจังหวัด' }]} label="จังหวัด (Province)" name="cust_city">
                <Select
                  disabled={disableinput}
                  placeholder='จังหวัด'
                  showSearch
                  options={provincethai}
                  onChange={provinceinput}
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase()) ||
                    (option?.value?.toLowerCase() ?? '').includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item rules={[{ required: true, message: 'กรุณากรอกอำเภอ' }]} label="อำเภอ/เขต (District)" name="cust_District">
                {/* <Input placeholder="อำเภอ" disabled={disableinput} value={formValue.district} onChange={datainputChange} name="district" /> */}
                <Select
                  disabled={disableinput}
                  placeholder='อำเภอ'
                  showSearch
                  options={DistrictThai}
                  onChange={districts}
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase()) ||
                    (option?.value?.toLowerCase() ?? '').includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item rules={[{ required: true, message: 'กรุณากรอกตำบล/แขวง' }]} label="แขวง / ตำบล (Sub-District)" name="cust_sub_district">
                <Select
                  disabled={disableinput}
                  placeholder='ตำบล/แขวง'
                  showSearch
                  options={TambonThai}
                  onChange={Tambon}
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase()) ||
                    (option?.value?.toLowerCase() ?? '').includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item rules={[{ required: true, message: 'กรุณากรอกรหัสไปรษณีย์' }]} label="รหัสไปรษณีย์ (Postal Code)" name="cust_Postcode">
                <Select
                  disabled={disableinput}
                  placeholder='รหัสไปรษณีย์'
                  showSearch
                  options={zipcodes}
                  onChange={postcodedata}
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase()) ||
                    (option?.value?.toLowerCase() ?? '').includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอก E-mail',
                  },
                  {
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'กรุณากรอก E-mail ให้ถูกต้อง',
                  },
                ]}
                label="Email"
                name="cust_email"
                initialValue={formValue.cust_email}
              >
                <Input placeholder="Email" disabled={disableinput} name="cust_email" />
              </Form.Item>
              {/* {!checkbox && ( */}
                <Form.Item>
                  <Checkbox
                    checked={email}
                    onChange={(e) => setemailcheck(e.target.checked)}
                    disabled={disableinput}
                  >
                    ยินดีสมัครรับข่าวสารและโปรโมชันพิเศษจาก Bewell
                  </Checkbox>
                </Form.Item>
              {/* )} */}



              {!disablebutton1 && (
                <Form.Item>
                  <GreenButton block onClick={firstsubmitfn}>แก้ไขข้อมูล</GreenButton>
                </Form.Item>
              )}

              {disablebutton && (
                <Form.Item>
                  <Row>
                    <Col span={12} >
                      <CancelButton onClick={disables}>ย้อนกลับ</CancelButton>
                    </Col>
                    <Col span={12}>
                      <GreenButton htmlType='submit' onClick={secondsubmitfn}>บันทึกข้อมูล</GreenButton>
                    </Col>
                  </Row>
                </Form.Item>
              )}
              {!disablebutton2 && (
                <Form.Item>
                  <Row>
                    <Col span={12} >
                      <CancelButton onClick={disables2}>ย้อนกลับ</CancelButton>
                    </Col>
                    <Col span={12}>
                      <GreenButton onClick={handleSubmit}>ยืนยัน</GreenButton>
                    </Col>
                  </Row>
                </Form.Item>
              )}


            </Form>
          )}



        </div>

      </div>

      {/* </Box> */}
    </GuestLayout>
  );
}